export const List = () => import("./List.vue");
export const Summary = () => import("./Summary.vue");
export const TradeSummary = () => import("./TradeSummary.vue");
export const CadresSummary = () => import("./CadresSummary.vue");
